import { css } from '@emotion/react'
import { Flow, Tag, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import { HLabel } from 'components/HLabel'
import { Telefone } from 'components/label'
import { ResponsavelTecnicoImovel } from 'graphql/types.generated'

interface ResponsavelTecnicoProps {
  responsavelTecnico: ResponsavelTecnicoImovel
}

export function ResponsavelTecnicoImovelList(props: Readonly<ResponsavelTecnicoProps>) {
  const {
    responsavelTecnico: { nome, cargo, cns, contato },
  } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const placeholderStyle = {
    color: theme.pallete.text.secondary,
    fontStyle: 'italic',
  }

  return (
    <Box>
      <Flow direction='vertical' gap={0.5} justifyItems='start'>
        <Tag icon='userFilled' style={styles.tag}>
          Responsável técnico
        </Tag>
        <HLabel title={`${nome.titleCase()} |`} placeholder='Cargo não informado' placeholderStyle={placeholderStyle}>
          {cargo && cargo.titleCase()}
        </HLabel>
        <Flow direction='horizontal' justifyItems='start'>
          <HLabel title='CNS' placeholder='Não informado' placeholderStyle={placeholderStyle}>
            {cns}
          </HLabel>
          <HLabel title='Telefone' placeholder='Não informado' placeholderStyle={placeholderStyle}>
            {contato ? <Telefone value={contato} /> : null}
          </HLabel>
        </Flow>
      </Flow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  tag: css`
    color: ${theme.pallete.primary.c40};
    background-color: transparent;
    border: 1px solid;
  `,
})
